
import React, { useState } from "react";

export const useNpsSingleSelect = (initialValue: string[]) => {
    const [selectedNps, setSelected] = useState<string[]>(initialValue);
  
    const onChangeNps = (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      const index = selectedNps.indexOf(value);
      if (index === -1) {
        setSelected([value]);
      }
    };
  
    const isSelectedNps = (value: string) => {
      return selectedNps.includes(value);
    };
  
    return { selectedNps, isSelectedNps, onChangeNps };
};